import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type TransactionCode } from './get-transaction-codes';

export interface UpdateTransactionCode {
  transactionCodeId: string;
  code: string;
  description: string;
  sessionId?: string | null;
  sessionName?: string | null;
  entities?: Array<Entity>;
  isAllClassSelected?: boolean;
}

export interface Entity {
  entityId: string;
  entityName: string;
}

export const updateTransactionCode = async ({
  transactionCodeId,
  ...params
}: UpdateTransactionCode) => {
  const response = await baseAPI.patch<TransactionCode>(
    `transaction-code/${transactionCodeId}`,
    {
      ...params,
    },
  );
  return response.data;
};

export const useUpdateTransactionCode = () => {
  return useMutation({
    mutationFn: (params: UpdateTransactionCode) =>
      updateTransactionCode(params),

    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRANSACTION_CODE],
      });
    },
  });
};
